export default "__VITE_ASSET__BPzcaOT4__"